const productList_CN_Locale = {
    'productList.HotlineService': '热线服务',
    'productList.BusinessCooperation': '商务合作',
    'productList.FollowRayShape': '关注度影',
    'productList.OnlineConsultation':'在线咨询',
    'productList.products': '产品列表',
    'productList.solutions': '解决方案',
    'productList.AboutUs': '关于我们',
    'productList.productsItem1': '一站式医学影像专用标注软件',
    'productList.productsItem2': '产前智能超声筛查系统',
    'productList.productsItem3': '盆底智能超声筛查系统',
    'productList.productsItem4': '婴幼儿髋关节智能超声影像处理系统',
    'productList.productsItem5': '乳腺超声辅助筛查系统',
    'productList.productsItem6': '甲状腺超声辅助筛查评估系统',
    'productList.productsItem7': '心脏超声智能辅助筛查系统',
    'productList.productsItem8': '辅助生殖自动测量系统',
    'productList.productsItem9': '智能超声质控平台',
    'productList.solutionsItem1': '全栈式智能超声解决方案',
    'productList.solutionsItem2': '超声影像AI部署平台NiCE',
    'productList.aboutItem1': '关于度影',
    'productList.aboutItem2': '荣誉资质',
    'productList.aboutItem3': '企业文化',
}
export default productList_CN_Locale
